export default __webpack_public_path__ + "static/media/casters.96dc67c1.png";